<template>
    <div class="etm-help-panel" :class="{'etm-help-panel-open': helpPanelOpen }">
        <div class="etm-inner-panel">
            <h3 class="etm-help-panel-title">
                {{helpPanelContent[page].title}}
            </h3>
            <div class="etm-help-panel-content" v-html="helpPanelContent[page].content"></div>
        </div>
        <div class="etm-help-panel-pagination">
            <span>{{page + 1}}/{{helpPanelContent.length}}</span>
            <span>
                    <a class="etm-link-button" :class="{'etm-link-button-disabled': ( page <= 0 ) }"
                       @click="page = (page <= 0 ) ? 0 : page - 1">{{editorStrings.previous}}</a>
                    |
                    <a class="etm-link-button"
                       :class="{'etm-link-button-disabled': ( page >= helpPanelContent.length - 1 ) }"
                       @click="page = (page >= helpPanelContent.length - 1) ? page : page + 1">{{editorStrings.next}}</a>
                </span>
        </div>
    </div>
</template>

<script>
    export default {
        props : [
            'helpPanelContent',
            'editorStrings',
            'helpPanelOpen'
        ],
        data() {
            return {
                page : 0
            }
        },
        watch : {
            page : function () {
                window.dispatchEvent(new Event('etm_help_panel_changed'));
                window.dispatchEvent(new Event(this.helpPanelContent[this.page].event));
            },
            helpPanelOpen : function () {
                if( this.helpPanelOpen ){
                    window.dispatchEvent( new Event( this.helpPanelContent[ this.page ].event ) );
                }else{
                    window.dispatchEvent(new Event('etm_help_panel_changed'));
                }
            }
        }
    }
</script>